import React from "react";

const PropertyList = ({
  properties,
  insertFieldInput,
  customStyles
}) => {
  return (
    <div className='properties-list-container' style={customStyles}>
      <div className="panel-options-title">Ingresa un valor o selecciona un campo</div>
      {properties.map((field, index) => (
        <div key={`customer-field-${index}`}
          className="panel-options-items cursor-pointer"
          onClick={() => insertFieldInput(field)}>
          {field[0]} <small className="c-grey">{`{{${field[1]}}}`}</small>
        </div>
      ))}
    </div>
  );
};

export default PropertyList;
